export const getDefaultRoutePath = (routes = []) => {
  let defaultRoute
  const getDefaultPathRecursive = (route) => {
    if (route.defaultPath) {
      return route.navPath || route.path || '/'
    }
    if (!route.subMenu || route.subMenu.length === 0) {
      return
    }

    let defaultPath
    for (const subRoute of route.subMenu) {
      defaultPath = getDefaultPathRecursive(subRoute)
      if (defaultPath) {
      	break
      }
    }
    return defaultPath
  }

  for (const route of routes) {
    defaultRoute = getDefaultPathRecursive(route)
    if (defaultRoute) {
      break
    }
  }
  return defaultRoute ? defaultRoute : '/'
}
